import {
  CloseButton as MantineCloseButton,
  CloseButtonProps,
  createPolymorphicComponent,
} from '@mantine/core';
import React from 'react';

export type ICloseButtonProps = CloseButtonProps;

const CloseButtonBase = React.forwardRef<HTMLButtonElement, ICloseButtonProps>(
  (props, ref) => <MantineCloseButton {...props} ref={ref} />,
);
CloseButtonBase.displayName = 'CloseButton';

/** @registry Design-layer pass-through over Mantine CloseButton; import this instead of @mantine/core CloseButton outside src/design. */
export const CloseButton = createPolymorphicComponent<
  'button',
  ICloseButtonProps
>(CloseButtonBase);
